"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var bind_1 = require("../bind");
var create_credit_card_form_1 = require("../credit_cards/create_credit_card_form");
var onboarding_form_save_button_1 = require("../onboarding/onboarding_form_save_button");
var selectable_credit_card_list_1 = require("../onboarding/selectable_credit_card_list");
var credit_card_form_toggle_button_1 = require("../onboarding/credit_card_form_toggle_button");
var rql_validation_errors_1 = require("../onboarding/rql_validation_errors");
var card_data_1 = require("../credit_cards/card_data");
var billing_method_operation_inputs_1 = require("./billing_method_operation_inputs");
var BillingMethodForm = /** @class */ (function (_super) {
    tslib_1.__extends(BillingMethodForm, _super);
    function BillingMethodForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            tokenizedCreditCardData: card_data_1.buildTokenizedCreditCardData(),
            cardData: card_data_1.buildCardData(),
            billingCardAddress: _this.defaultBillingCardAddress,
            showExistingCreditCards: _this.hasCardsOnFile,
            selectedCreditCardId: _this.defaultSelectedCreditCardId,
            editingCard: false,
        };
        return _this;
    }
    Object.defineProperty(BillingMethodForm.prototype, "defaultBillingCardAddress", {
        get: function () {
            return tslib_1.__assign(tslib_1.__assign({}, card_data_1.buildBillingCardAddress()), { countryCode: this.props.defaultOriginCountryCode });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BillingMethodForm.prototype, "hasCardsOnFile", {
        get: function () {
            return this.props.creditCards.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BillingMethodForm.prototype, "primaryBillingCard", {
        get: function () {
            return this.props.creditCards.find(function (creditCard) { return creditCard.primaryBilling; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BillingMethodForm.prototype, "defaultSelectedCreditCardId", {
        get: function () {
            if (!this.hasCardsOnFile) {
                return '';
            }
            return this.primaryBillingCard ? this.primaryBillingCard.id : this.props.creditCards[0].id;
        },
        enumerable: true,
        configurable: true
    });
    BillingMethodForm.prototype.findCard = function (cardId) {
        return this.props.creditCards.find(function (creditCard) { return creditCard.id === cardId; });
    };
    BillingMethodForm.prototype.cardData = function (cardId) {
        var _a = this.findCard(cardId), cardholderName = _a.cardholderName, cardType = _a.cardType, last4 = _a.last4;
        return {
            cardholderName: cardholderName,
            cardType: cardType,
            last4: last4,
        };
    };
    BillingMethodForm.prototype.billingCardAddress = function (cardId) {
        var address = this.findCard(cardId).address;
        if (address) {
            return ({
                postalCode: address.postalCode,
                countryCode: address.countryCode,
            });
        }
        return this.defaultBillingCardAddress;
    };
    BillingMethodForm.prototype.onTokenizedFieldUpdate = function (newTokenizedFields) {
        this.setState(function (previousState) { return ({
            tokenizedCreditCardData: tslib_1.__assign(tslib_1.__assign({}, previousState.tokenizedCreditCardData), newTokenizedFields),
        }); });
    };
    BillingMethodForm.prototype.updateBillingMethod = function (event) {
        event.preventDefault();
        var mutationData = billing_method_operation_inputs_1.buildUpdateBillingMethodMutationInput({
            cardData: this.state.cardData,
            tokenizedCreditCardData: this.state.tokenizedCreditCardData,
            billingCardAddress: this.state.billingCardAddress,
            editingCard: this.state.editingCard,
            selectedCreditCardId: this.state.selectedCreditCardId,
            useExistingCreditCard: this.state.showExistingCreditCards,
            returnUrl: this.props.returnURL,
        });
        this.props.updateMyShopBillingMethod(mutationData);
    };
    BillingMethodForm.prototype.onBillingCardAddressUpdate = function (updatedBillingAddress) {
        this.setState(function (previousState) { return ({
            billingCardAddress: tslib_1.__assign(tslib_1.__assign({}, previousState.billingCardAddress), updatedBillingAddress),
        }); });
    };
    BillingMethodForm.prototype.onCardDataUpdate = function (newCardData) {
        this.setState(function (previousState) { return ({
            cardData: tslib_1.__assign(tslib_1.__assign({}, previousState.cardData), newCardData),
        }); });
    };
    BillingMethodForm.prototype.handleEditClick = function (cardId) {
        this.setState({
            editingCard: true,
            billingCardAddress: this.billingCardAddress(cardId),
            cardData: this.cardData(cardId),
            selectedCreditCardId: cardId,
            showExistingCreditCards: false,
        });
    };
    BillingMethodForm.prototype.toggleShowExistingCreditCards = function (event) {
        var _this = this;
        event.preventDefault();
        this.setState(function (previousState) { return ({
            cardData: card_data_1.buildCardData(),
            billingCardAddress: _this.defaultBillingCardAddress,
            editingCard: false,
            showExistingCreditCards: !previousState.showExistingCreditCards,
        }); });
    };
    BillingMethodForm.prototype.setSelectedCreditCardId = function (id) {
        this.setState({
            selectedCreditCardId: id,
        });
    };
    BillingMethodForm.prototype.renderChooseExistingCardButton = function () {
        if (!this.hasCardsOnFile)
            return null;
        return (React.createElement(credit_card_form_toggle_button_1.default, { classes: "button mt-2", onClick: this.toggleShowExistingCreditCards, buttonText: I18n.t('discovery.coreOnboarding.chooseExistingCard') }));
    };
    BillingMethodForm.prototype.renderFormContent = function () {
        if (this.state.showExistingCreditCards) {
            return (React.createElement(selectable_credit_card_list_1.default, { creditCards: this.props.creditCards, showEditURL: this.props.showEditURL, setSelectedCreditCardId: this.setSelectedCreditCardId, selectedCreditCardId: this.state.selectedCreditCardId, handleEditClick: this.handleEditClick },
                React.createElement(credit_card_form_toggle_button_1.default, { classes: "button button--blue", onClick: this.toggleShowExistingCreditCards, buttonText: I18n.t('discovery.coreOnboarding.addNewCard') })));
        }
        return (React.createElement(create_credit_card_form_1.default, { onCardDataUpdate: this.onCardDataUpdate, onTokenizedFieldUpdate: this.onTokenizedFieldUpdate, onBillingCardAddressUpdate: this.onBillingCardAddressUpdate, billingCardAddress: this.state.billingCardAddress, cardData: this.state.cardData, user: this.props.user, countries: this.props.countries }, this.renderChooseExistingCardButton()));
    };
    BillingMethodForm.prototype.renderDescription = function () {
        if (!this.props.description) {
            return null;
        }
        return (React.createElement("div", { className: "form-section__info" },
            React.createElement("div", { className: "form-section__title" }, I18n.t('discovery.coreOnboarding.billingMethod.subTitle')),
            React.createElement("p", { className: "form-section__description" }, this.props.description)));
    };
    BillingMethodForm.prototype.renderTitle = function () {
        if (!this.props.title) {
            return null;
        }
        return (React.createElement("div", { className: "form-section-wrapper__header" },
            React.createElement("h2", { className: "form-section-wrapper__title" }, this.props.title)));
    };
    BillingMethodForm.prototype.renderForm = function () {
        var _a = this.props, isSaving = _a.isSaving, validationErrors = _a.validationErrors;
        return (React.createElement("div", { className: "form-section-wrapper__body" },
            React.createElement(rql_validation_errors_1.default, { validationErrors: validationErrors }),
            React.createElement("div", { className: "form-section" },
                React.createElement("div", { className: "form-section__wrapper" },
                    this.renderDescription(),
                    React.createElement("div", { className: "form-section__content" }, this.renderFormContent()))),
            React.createElement(onboarding_form_save_button_1.default, { isSaving: isSaving, onClick: this.updateBillingMethod })));
    };
    BillingMethodForm.prototype.render = function () {
        return (React.createElement("div", { className: "form-section-wrapper" },
            this.renderTitle(),
            this.renderForm()));
    };
    tslib_1.__decorate([
        bind_1.default
    ], BillingMethodForm.prototype, "onTokenizedFieldUpdate", null);
    tslib_1.__decorate([
        bind_1.default
    ], BillingMethodForm.prototype, "updateBillingMethod", null);
    tslib_1.__decorate([
        bind_1.default
    ], BillingMethodForm.prototype, "onBillingCardAddressUpdate", null);
    tslib_1.__decorate([
        bind_1.default
    ], BillingMethodForm.prototype, "onCardDataUpdate", null);
    tslib_1.__decorate([
        bind_1.default
    ], BillingMethodForm.prototype, "handleEditClick", null);
    tslib_1.__decorate([
        bind_1.default
    ], BillingMethodForm.prototype, "toggleShowExistingCreditCards", null);
    tslib_1.__decorate([
        bind_1.default
    ], BillingMethodForm.prototype, "setSelectedCreditCardId", null);
    return BillingMethodForm;
}(React.Component));
exports.default = BillingMethodForm;
//# sourceMappingURL=billing_method_form.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/billing/billing_method_form.js
// module id = IXZX
// module chunks = 20 21